import React, { useEffect, useState,useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons'; 
import { Link } from 'react-router-dom'; 
import ParkingMenu from '../Assets/images/parkingMenu.svg';
import Dashboard from '../Assets/images/dashboard.svg';
import Templates from '../Assets/images/templates.svg';
import SaveTemplate from '../Assets/images/save-template.svg';
import MenuImg from '../Assets/images/menu.svg';
import SaveImg from '../Assets/images/save.svg';
import LogOutImg from '../Assets/images/logout.svg';
import ProfileImg from '../Assets/images/profile.svg';
import ProfilePic from '../Assets/images/profile-pics.png';
import NotificationHeader from '../Assets/images/notification.svg';
import { Tabs, Dropdown, Menu, Modal, Form, Input, Button, Select, Checkbox } from 'antd';
import SaveTemplate_icon from '../Assets/images/savetemplate.svg'
import { useSelector } from 'react-redux';
import { post,get } from '../Services/Api';
import {useDispatch } from 'react-redux';
import { setPlanningBuildPayload } from '../Redux/PlanningSpaces'
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import InfoImg from '../Assets/images/info.svg';
import UserIcon from './../Assets/images/user.svg';
import { useSnapshot } from '../Components/SnapshotContext';
import snapshot from '../../src/Assets/images/downloadzip.svg'
import LogoutConformation from '../Components/LogoutConformation';
import Avatar1 from '../Assets/images/avatar.png'

const SubLayout = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Initial state for sidebar
  const [admin_id, setAdminId] = useState(null);
  const [template_name, settemplate_name] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [templateList,setTemplateList] = useState([]);
  const [userRole,setuseRole] = useState(false);

  const [isLogoutModalVisible,setisLogoutModalVisible] = useState(false)

  const [snapshotKeys] = useState(
    [
        "overviewDashboard",
        // "secondDiv",
        "Heatmap",
        "weekdayBarGraphSnap",
        "weekdayLineGraphSnap",
        "weekendBarGraphSnap",
        "weekendLineGraphSnap",
  
        "weekendUniqueBarGraphSnap",
        "weekdayUniqueBarGraphSnap",
        "weekdayUniqueLineGraphSnap",
        "weekendUniqueLineGraphSnap",
        "parkingDistibutionTable"
      ]
  )

  const planningBuildPayload = useSelector((state)=>state.planning.planningBuildPayload);
  const parkingDemandData = location.state?.parkingDemandData || [];

  const { takeMultipleSnapshots } = useSnapshot();
//   console.log("planningBuildPayload::",planningBuildPayload);

  // Check rehydration status



  const handleSnapshot = (e) => {
    e.preventDefault();
  
    // List all the snapshot keys you want to capture
    // const snapshotKeys = [
    //   "overviewDashboard",
    //   "secondDiv",
    //   "weekdayBarGraphSnap",
    //   "weekdayLineGraphSnap",
    //   "weekendBarGraphSnap",
    //   "weekendLineGraphSnap",

    //   "weekendUniqueBarGraphSnap",
    //   "weekdayUniqueBarGraphSnap",
    //   "weekdayUniqueLineGraphSnap",
    //   "weekendUniqueLineGraphSnap",
    //   "parkingDistibutionTable"
    // ];
    
  
    takeMultipleSnapshots(snapshotKeys);
  };


  useEffect(() => {
    if (planningBuildPayload) {
        // console.log("Updated planningBuildPayload:", planningBuildPayload);
    }else if(planningBuildPayload === null){
        localStorage.getItem("")
    }
}, [planningBuildPayload]);

const handleGetMyProfile = ()=>{
    navigate('/spaceSelect/my-profile')
}

const handleLogoutConformation = ()=>{
    setisLogoutModalVisible(true)
  }
  
  const handleLogoutModalCancel =()=>{
    setisLogoutModalVisible(false)
  }

const handleLogout = ()=>{
    localStorage.removeItem('accessToken');
    localStorage.removeItem('adminId');
    localStorage.removeItem('firstName');
    localStorage.removeItem('roles');

    // Redirect to login page
    navigate('/');
}

useEffect(() => {
    // Check if planningBuildPayload is null
    if (planningBuildPayload === null) {
      // Retrieve from localStorage if null
      const storedPayload = localStorage.getItem('planningBuildPayload');
      
      if (storedPayload) {
        // Parse the stored string back to an object
        const parsedPayload = JSON.parse(storedPayload);
        console.log("Retrieved payload from localStorage:", parsedPayload);
        
        // Dispatch to Redux to set planningBuildPayload
        // dispatch(setPlanningBuildPayload(parsedPayload));
      } else {
        console.log("No payload found in localStorage");
      }
    }
  }, [planningBuildPayload]); // Re-run effect when planningBuildPayload changes


  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev); // Toggle sidebar state
  };
  

  useEffect(() => {
    const storedAdminId = localStorage.getItem("adminId"); 
    setAdminId(storedAdminId); // Store it in state
    const user_role = localStorage.getItem("roles");
    setuseRole(user_role === "admin");
  }, []);

  useEffect(() => {
    if (!admin_id) return;
    fetchTemplateList();
  }, [admin_id]);

  // Fetch templates from API
  const fetchTemplateList = async () => {
    try {
      const response = await get(`listtemplates?admin_id=${admin_id}`);
      if (response?.status === 200) {
        setTemplateList(response.data);
      } else {
        throw new Error("Invalid API response");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      notification.error({
        message: "Error Fetching Templates",
        description: "Unable to fetch templates. Please try again later.",
      });
    }
  };


  

  const handletemplateName = (e)=>{
    settemplate_name(e.target.value)
  }

  const handleMenuClick = () => {
        settemplate_name("") 
        setIsModalVisible(true); // Open the modal
    };
    const handleOk = () => {
      setIsModalVisible(false); // Close the modal
    };
    
    const handleCancel = () => {
      setIsModalVisible(false); // Close the modal
    };

    const handleWarningCancel = ()=>{
        setIsWarningModalVisible(false)
    }

    const handleNavigation = (path) => {
        if (!isTemplateSelected && path === '/dashboard') {
            // If no template is selected, show modal
            setIsWarningModalVisible(true);
        } else {
            // Proceed with navigation
            navigate(path);
        }
    };

    const renderWarningModalContent = () => (
        <div>
            <h6>Please Select a Template</h6>
            <div className="w-100 d-flex align-items-center info-msg mb-4  mt-4">
            <img src={InfoImg} className="" style={{width: '20px'}} />
            <p className="mb-0 ms-4">You need to select a template before accessing the dashboard. </p>
            </div>
            <div className="w-100 text-end">
            <button
                className="btn btn-primary"
                onClick={() => {
                    setIsWarningModalVisible(false);
                    navigate('/dashboard/templates'); // Redirect to templates selection
                }}
            >
                OK
            </button>
            </div>
            
        </div>
    );

    const renderModalContent = () => {
        return (
            <Form layout="vertical">
               <div className="w-100 text-center">
                    <img src={SaveImg} al="" className="mb-2" />
                    <h5>
                    Save Template
                    </h5>
               </div>
                {/* <Form.Item
                    name="template_name"
                    className="mt-2"
                    rules={[
                        { required: true, message: 'Please enter the name' },
                    ]}
                >
                    <Input placeholder="Please enter the name" value={template_name} onChange={handletemplateName} className="mt-4" />
                </Form.Item> */}

                <div className="mb-3 mt-2">
                    <input
                    type="text"
                    id="templateName"
                    className="form-control mt-4"
                    placeholder="Provide a suitable name"
                    value={template_name}
                    onChange={handletemplateName}
                    required
                    />
                    <div className="invalid-feedback">Please enter the name</div>
                </div>

               
                <Form.Item className="text-end">
                    <button className="me-2 btn" onClick={handleCancel}>
                        Cancel
                    </button>
                    <button type="submit"  className="btn btn-primary"  onClick={handleTemplateSave}>
                        Save
                    </button>
                </Form.Item>
            </Form>
        );
      };
     
      const dropdownMenu = (
        <Menu  style={{minWidth: '200px'}}>
            <Menu.Item onClick={handleMenuClick} key="1">Save Template</Menu.Item>
            {/* <Menu.Item key="2">Save a Copy</Menu.Item> */}
        </Menu>
    );

    const dropdownMenuProfile = (
        <Menu  style={{minWidth: '200px'}}>
            <Menu.Item 
            key="1"
            onClick={handleGetMyProfile}
            style={{padding: '10px'}}>
                <img src={ProfileImg} alt="" className="mx-2" />
                My Profile</Menu.Item>
            <Menu.Item
             key="2"
             onClick={handleLogoutConformation}
            style={{padding: '10px'}}>
            <img src={LogOutImg} alt="" className="mx-2" />
                LogOut</Menu.Item>
            {/* <Menu.Item key="2">Save a Copy</Menu.Item> */}
        </Menu>
    );


    console.log("parkingDemandData Structure::",parkingDemandData);
    
 
    const handleTemplateSave = async () => {

        if (!planningBuildPayload) {
            console.error("Error: planningBuildPayload is null or undefined!");
            return; // Handle the case where the payload is not available
        }
        if (!template_name){
            notification.error({
                message: 'Error Saving Template',
                description: 'There was an error while saving the template. Please enter template name.',
            });
            return;
        }

        const templateNames = templateList.map((name) => name.template_name);
        if (templateNames.includes(template_name)) {
            notification.error({
                message: 'Template Name Already Exists',
                description: `The template name "${template_name}" already exists. Please choose a different name.`,
            });
            return; // Exit if template_name already exists
        }

        const ParkingDemandData_payload = parkingDemandData.map((item) => {
            return {
              land_use_values: [item.project_data?.quantity || 0],
              land_use_units: item.project_data?.unit,
              land_use_descriptions: [
                item.land_use_type || "",
                // item.land_use_type_new || "",
                item.description || "",
              ],
              usedratios: {
                weekday: {
                  employee_ratio: item.usedratios?.weekday?.employee_ratio || 0.0,
                //   months_ratio: item.usedratios?.weekday?.months_ratio || [], 
                //   time_ratio: item.usedratios?.weekday?.time_ratio || [], 
                  visitor_ratio: item.usedratios?.weekday?.visitor_ratio || 0.0,

                  weekday_category_flag:item.usedratios?.weekday?.weekday_category_flag ?? false,
                  weekday_employee_captive_ratio_daylight: item.usedratios?.weekday?.weekday_employee_captive_ratio_daylight || 0.0,
                    weekday_employee_captive_ratio_evening: item.usedratios?.weekday?.weekday_employee_captive_ratio_evening || 0.0,
                    weekday_employee_driving_daylight: item.usedratios?.weekday?.weekday_employee_driving_daylight || 0.0,
                    weekday_employee_driving_evening: item.usedratios?.weekday?.weekday_employee_driving_evening || 0.0,
                    weekday_employee_montly_ratio: item.usedratios?.weekday?.weekday_employee_montly_ratio || 0.0,
                    weekday_employee_time_ratio: item.usedratios?.weekday?.weekday_employee_time_ratio || 0.0,

                    weekday_visitor_captive_ratio_daylight: item.usedratios?.weekday?.weekday_visitor_captive_ratio_daylight || 0.0,
                    weekday_visitor_captive_ratio_evening: item.usedratios?.weekday?.weekday_visitor_captive_ratio_evening || 0.0,
                    weekday_visitor_driving_daylight: item.usedratios?.weekday?.weekday_visitor_driving_daylight || 0.0,
                    weekday_visitor_driving_evening: item.usedratios?.weekday?.weekday_visitor_driving_evening || 0.0,
                    weekday_visitor_montly_ratio: item.usedratios?.weekday?.weekday_visitor_montly_ratio || 0.0,
                    weekday_visitor_time_ratio: item.usedratios?.weekday?.weekday_visitor_time_ratio || 0.0,

                    weekday_visitor_time_ratio:item.usedratios?.weekday?.weekday_visitor_time_ratio || 0.0
                },
                weekend: {
                  employee_ratio: item.usedratios?.weekend?.employee_ratio || 0.0,
                //   months_ratio: item.usedratios?.weekend?.months_ratio || [], 
                //   time_ratio: item.usedratios?.weekend?.time_ratio || [], 
                  visitor_ratio: item.usedratios?.weekend?.visitor_ratio || 0.0,

                  weekend_category_flag:item.usedratios?.weekend?.weekend_category_flag ?? false,
                  weekend_employee_captive_ratio_daylight: item.usedratios?.weekend?.weekend_employee_captive_ratio_daylight || 0.0,
                  weekend_employee_captive_ratio_evening: item.usedratios?.weekend?.weekend_employee_captive_ratio_evening || 0.0,
                  weekend_employee_driving_daylight: item.usedratios?.weekend?.weekend_employee_driving_daylight || 0.0,
                  weekend_employee_driving_evening: item.usedratios?.weekend?.weekend_employee_driving_evening || 0.0,
                  weekend_employee_montly_ratio: item.usedratios?.weekend?.weekend_employee_montly_ratio || 0.0,
                  weekend_employee_time_ratio : item.usedratios?.weekend?.weekend_employee_time_ratio || 0.0,

                  weekend_visitor_captive_ratio_daylight:item.usedratios?.weekend?.weekend_visitor_captive_ratio_daylight || 0.0,
                    weekend_visitor_captive_ratio_evening: item.usedratios?.weekend?.weekend_visitor_captive_ratio_evening || 0.0,
                    weekend_visitor_driving_daylight: item.usedratios?.weekend?.weekend_visitor_driving_daylight || 0.0,
                    weekend_visitor_driving_evening: item.usedratios?.weekend?.weekend_visitor_driving_evening || 0.0,
                    weekend_visitor_montly_ratio: item.usedratios?.weekend?.weekend_visitor_montly_ratio || 0.0,
                    weekend_visitor_time_ratio: item.usedratios?.weekend?.weekend_visitor_time_ratio || 0.0,

                    weekend_visitor_time_ratio:item.usedratios?.weekend?.weekend_visitor_time_ratio || 0.0,

                    
                },
              },
            };
          });
          
          console.log(" ParkingDemandData_payload New Payload Structure::", ParkingDemandData_payload);

    

        const payload = {
            admin_id: parseInt(admin_id),
            template_name: template_name,
            template_json: ParkingDemandData_payload,
            // template_json: planningBuildPayload
        };
        
    
        console.log("payload For Saving Template::", payload);
        
    
        try {
            // Assuming the API function is post and it returns a response
            const graphDemandResponse = await post('savetemplate', payload);
            // const graphDemandResponse = await post('http://192.168.96.120:5000/apis/savetemplate', payload);
            
            // Check the response if it's successful (you can adjust this based on actual API response)
            if (graphDemandResponse?.status === 200) {
                // Show success notification
                notification.success({
                    message: 'Template Saved Successfully',
                    description: 'Your template has been saved successfully!',
                });
                setIsModalVisible(false);
            } else {
                // Show error notification if API response indicates failure
                notification.error({
                    message: 'Error Saving Template',
                    description: 'There was an error while saving the template. Please try again.',
                });
            }
        } catch (error) {
            console.error("Error fetching parking demand data:", error);
            
            // Show error notification for failed request
            notification.error({
                message: 'API Request Failed',
                description: 'There was an issue with the API request. Please check your connection.',
            });
        }
    };
  return (
    <div style={{background: 'linear-gradient(180deg, #F4F6F9 0%, #E6F3F7 100%)' }}>
        <header className="home-section-header" style={{background: '#F4F6F9'}}>
        <div className="home-content" >
            <div className="d-flex align-items-center w-100">
                <span className="bx-menu d-flex align-items-center w-100">
                    {/* <img src={BxMenu} alt="" style={{ width: '25px' }} /> */}
                    <h4 className="me-4 mb-0">SHARED PARKING</h4>
                    {/* <h6 className="mb-0">Dashboard/Office</h6> */}
                    {location.pathname === '/dashboard' &&(
                    <h6 className="mb-0">Dashboard</h6>
                    )}
                  
             
                </span>
                <div className="custom-menubar-item d-flex justify-content-end w-100 align-items-center">
                    <div className="d-flex justify-content-center align-items-center">
                    {/* <button className=" btn-primary me-4"  style={{ borderRadius:'30px', width: '50px', height: '50px', border: '0'}}>
                        <img src={SaveTemplate} alt="" className=""/>
                    </button> */}
                    {/* <Dropdown overlay={dropdownMenuProfile} placement="bottomRight"> */}
                    {location.pathname === '/dashboard' &&(
                            <a 
                            onClick={
                                 handleSnapshot
                            }
                                //  takeMultipleSnapshots(
                                //     [
                                //         "overviewDashboard",
                                //         "secondDiv",
                                //         "weekendBarGraphSnap",
                                //         "weekdayBarGraphSnap",
                                //         "weekdayLineGraphSnap",
                                //         "weekendLineGraphSnap",
                                //         "weekendUniqueBarGraphSnap",
                                //         "weekdayUniqueBarGraphSnap",
                                //         "weekdayUniqueLineGraphSnap",
                                //         "weekendUniqueLineGraphSnap",
                                        
                                //         ]);
                                

                            className="me-4"
                            >
                                <div className="profile-img-content-snap" style={{cursor: 'pointer'}}>
                                    <img src={snapshot} alt="" style={{width: '24px'}} title="Snapshot" />
                                </div> 
                            </a>
                    )}

                    
                        {/* </Dropdown> */}
                    {location.pathname === '/dashboard' &&(
                    // <Dropdown overlay={dropdownMenu} placement="bottomRight">
                    <a onClick={handleMenuClick} className="me-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', borderRadius:'30px', width: '50px', height: '50px', border: '0', padding: '8px 23px',  background: '#000' }}>
                        <img src={SaveTemplate_icon} alt="" className="" title="Save template" /> 
                        
                    </a>
                // </Dropdown>
                )}
                      {/* <div className="notification-header">
                      <img src={NotificationHeader} alt="" />
                      </div> */}
                        <Dropdown overlay={dropdownMenuProfile} placement="bottomRight">
                            <a onClick={(e) => e.preventDefault()} className="">
                                <div className="profile-img-content">
                                    <img src={Avatar1} alt="" style={{width: '50px'}} />
                                </div> 
                            </a>
                        </Dropdown>
                        
                    </div>
                </div>
            </div>

        </div>
        </header>
        <div className={`home-section ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
          {/* sidebar */}
          <div className={`sidebar ${isSidebarOpen ? '' : 'close'}`}>
            <div className="logo-details py-3">
                
                    <img 
                        src={MenuImg} 
                        className="img-fluid" 
                        alt="" 
                        style={{width: '20px'}} 
                        onClick={toggleSidebar} // Removed () to avoid immediate call
                    />
              
            </div>
            <ul className="nav-links sidebar-accordion accordion" id="accordionExample">
                {/* <li>
                    <Link to="/dashboard" className="active">
                        <div className="sidebar-icon">
                            <img src={Dashboard} alt="" style={{width: '20px'}} />
                        </div>
                        <span className="link_name">DASHBOARD</span>
                    </Link>
                    <ul className="sub-menu close blank">
                        <li><a className="" href="/dashboard">DASHBOARD</a></li>
                    </ul>
                </li> */}

                    <li>
                        <Link
                            to="/dashboard"
                            // className="active"
                            className={location.pathname === '/dashboard' ? 'active' : ''}
                            onClick={(e) => {
                                    if (location.pathname === '/dashboard') {
                                        e.preventDefault(); // Prevent navigation if already on /dashboard
                                        return; // Skip further navigation
                                    }
                                    if (location.pathname === '/dashboard/my-profile')
                                    {
                                        e.preventDefault(); // Prevent default link behavior
                                        navigate(-1); // Go back to the previous page
                                        return;
                                    }
                                handleNavigation('/dashboard')}
                            }
                            title="DASHBOARD"
                        >
                            <div className="sidebar-icon">
                                <img src={Dashboard} alt="Dashboard icon" 
                                style={{ 
                                    width: '20px',
                                    filter: location.pathname === '/dashboard' ? 'invert(0%)' : 'invert(100%)',
                                 }} 
                                />
                            </div>
                            <span className="link_name">DASHBOARD</span>
                        </Link>
                        <ul className="sub-menu close blank">
                            <li><a className="" href="/dashboard">DASHBOARD</a></li>
                        </ul>
                    </li>

                <li>
                <Link 
                title="TEMPLATES"
                to="/spaceSelect/templates"
                className={location.pathname === '/spaceSelect/templates' ? 'active' : ''}
                >
                        <div className="sidebar-icon">
                            <img src={Templates} alt="Template icon" 
                            style={{ width: '20px',
                            filter: location.pathname === '/spaceSelect/templates' ? 'invert(100%)' : 'invert(0%)',}} 
                            />
                        </div>
                        <span className="link_name">TEMPLATES </span>
                    </Link>
                    <ul className="sub-menu blank">
                        <li>
                        <a className="link_name" href="/spaceSelect/templates">TEMPLATES</a>
                        </li>
                    </ul>
                </li>
                {/* <li>
                    <Link to="#">
                        <div className="sidebar-icon">
                            <img src={ParkingMenu} alt="" />
                        </div>
                        <span className="link_name"> QUERIES</span>
                    </Link>
                    <ul className="sub-menu blank">
                        <li><a className="link_name" href="#"> QUERIES</a></li>
                    </ul>
                </li> */}
                {userRole && (
                <li>
                    <Link to="/spaceSelect/user-management"  title="USER MANAGEMENT">
                    <div className="sidebar-icon">
                    <img src={UserIcon} alt="" style={{ width: '19px' }} />
                    </div>
                    <span className="link_name"> USER MANAGEMENT</span>
                    </Link>
                    <ul className="sub-menu blank">
                        <li><a className="link_name" href="#"> USER MANAGEMENT</a></li>
                    </ul>
                </li>
                )}
            </ul>
        </div>
          {/*  */}
          <div className="outlet-main-box">
            <Outlet/>
          </div>
        </div>
         {/* modal  */}
         <Modal
                title=""
                visible={isModalVisible}
                onOk={handleTemplateSave}
                onCancel={handleCancel}
                footer={null} // Remove default footer to use form's submit button
            >
                {renderModalContent()}
            </Modal>
            {/* end modal  */}

            <Modal
                title=""
                visible={isWarningModalVisible}
                onCancel={handleWarningCancel}
                footer={null} // Remove default footer to use form's submit button
            >
                {renderWarningModalContent()}
            </Modal>

            <LogoutConformation
            isVisible={isLogoutModalVisible}
            onCancel={handleLogoutModalCancel}
            onConfirm={handleLogout}
            message="Are you sure you want to logout?"
            />

    </div>
  )
}

export default SubLayout